import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import QAPage from './pages/QAPage';
import ContactPage from './pages/ContactPage';
import AboutPage from './pages/AboutPage';
import TeamPage from './pages/TeamPage';
import OriginPage from './pages/OriginPage';
import CareersPage from './pages/CareersPage';
import ProductsPage from './pages/ProductsPage';
import AgendaPage from './pages/AgendaPage';
import HealthcareAIGovernancePage from './pages/HealthcareAIGovernancePage';
import CombatVetPTSDPage from './pages/CombatVetPTSDPage';

function App() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/qa" element={<QAPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/origin" element={<OriginPage />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/agenda" element={<AgendaPage />} />
        <Route path="/veteran-ptsd" element={<CombatVetPTSDPage />} />
        <Route path="/regulation" element={<HealthcareAIGovernancePage />} />
        <Route path="/governance" element={<HealthcareAIGovernancePage />} />
        <Route path="/healthcare-ai-governance" element={<HealthcareAIGovernancePage />} />
        <Route path="/healthcare-ai-governance.html" element={<HealthcareAIGovernancePage />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
